// Versão do app - gerado automaticamente
export const APP_VERSION = '5.44'
export const BUILD_DATE = '29/05/2026, 04:00'
